import React from "react";
import Link from "@mui/material/Link";
import CustomContainer from "./CustomContainer";
import Box from "@mui/material/Box";

function Footer() {
  return (
    <CustomContainer sx={{ height: "5vh", marginTop: '20vh' }}>
      <Box
        sx={{
          fontSize: 16,
          color: "text.default",
        }}>
        ©Copyright 2023. All Rights Reserved. Powered by{" "}
        <Link
          href="https://www.e-verse.com"
          target={"_blank"}
          sx={{ color: "text.default" }}>
          e-verse
        </Link>
      </Box>
    </CustomContainer>
  );
}

export default Footer;
